<script lang="ts">
	//Services
	import { format } from '../../../../services/i18n';
	//Hooks
	import { createEventDispatcher, onMount } from 'svelte';
	//Components
	import FailedAction from '../WebHooksHelpers/FailedAction.svelte';
	import HooksWrapperV2 from '../WebHooksHelpers/HooksWrapperV2.svelte';

	export let deviceActions, type;

	/**
	 * it is here not in the device config, because it is optional to be filtered, only if the external switch is disable
	 */
	const device = deviceActions.device;
	$: noActions = Object.keys(deviceActions[device.id]).length === 0;
	let showActions = false;

	const dispatch = createEventDispatcher();

	const showHideActions = () => {
		if (Object.keys(deviceActions[device.id]).length > 0) {
			showActions = true;
		} else {
			showActions = false;
		}
	};

	/**
	 * May be could be handle better :()
	 */
	const actionTitleConfig = (action) => {
		//#region actions_description
		/****
            SHSW-1 and SHSW-PM - done

            btn_on_url 	        0 	URL to access when SW input is activated
            btn_off_url 	    0 	URL to access when SW input is deactivated
            out_on_url 	        0 	URL to access when output is activated
            out_off_url 	    0 	URL to access when output is deactivated
            longpush_url 	    0 	URL to access on longpush. Works only when button is configured as momentary, momentary_on_release or detached.
            shortpush_url 	    0 	URL to access on shortpush. Works only when button is configured as momentary, momentary_on_release or detached.
            lp_on_url 	        0 	If low-power switch add-on attached URL to access when LP switch is activated
            lp_off_url 	        0 	If low-power switch add-on attached URL to access when LP switch is deactivated
            ext_temp_over_url 	0-2 	If temperature add-on attached URL to invoke when temperature > ext_temp_over_value
            ext_temp_under_url 	0-2 	If temperature add-on attached URL to invoke when temperature < ext_temp_under_value
            ext_hum_over_url 	0 	If temperature add-on attached (DHT22 only) URL to invoke when humidity > ext_hum_over_value
            ext_hum_under_url 	0 	If temperature add-on attached (DHT22 only) URL to invoke when humidity < ext_hum_under_value
            -------------------------------------------------------------------

            SHSW-L - done

            btn1_on_url 	    0 	URL to access when SW input is activated
            btn1_off_url 	    0 	URL to access when SW input is deactivated
            btn1_longpush_url 	0 	URL to access on longpush. Works only when button is configured as momentary, momentary_on_release or detached.
            btn1_shortpush_url 	0 	URL to access on shortpush. Works only when button is configured as momentary, momentary_on_release or detached.
            btn2_on_url 	    0 	URL to access when SW input is activated
            btn2_off_url 	    0 	URL to access when SW input is deactivated
            btn2_longpush_url 	0 	URL to access on longpush. Works only when button is configured as momentary, momentary_on_release or detached.
            btn2_shortpush_url 	0 	URL to access on shortpush. Works only when button is configured as momentary, momentary_on_release or detached.
            out_on_url 	        0 	URL to access when output is activated
            out_off_url 	    0 	URL to access when output is deactivated
            -------------------------------------------------------------------


            SHSW-21 / SHSW-25 - done

            btn_on_url 	        0-1 	URL to access when SW input is activated
            btn_off_url 	    0-1 	URL to access when SW input is deactivated
            out_on_url 	        0-1 	URL to access when output is activated
            out_off_url 	    0-1 	URL to access when output is deactivated
            longpush_url 	    0-1 	URL to access on longpush. Works only when button is configured as momentary, momentary_on_release or detached.
            shortpush_url 	    0-1 	URL to access on shortpush. Works only when button is configured as momentary, momentary_on_release or detached.
            roller_open_url 	0 	URL to access when roller is open
            roller_close_url 	0 	URL to access when roller is closed
            roller_stop_url 	0 	URL to access when roller is stopped
            -------------------------------------------------------------------

            Plug - PLUG S - done

            btn_on_url 	        0 	URL to access when SW input is activated
            out_on_url 	        0 	URL to access when output is activated
            out_off_url 	    0 	URL to access when output is deactivated
            -------------------------------------------------------------------

            I3 - done

            btn_on_url 	            0-2 	URL to access when switch is ON (works only when btn_type=toggle)
            btn_off_url 	        0-2 	URL to access when switch is OFF (works only when btn_type=toggle)
            shortpush_url 	        0-2 	URL to access when switch is pressed short (works only when btn_type=momentary)
            longpush_url 	        0-2 	URL to access when switch is pressed long (works only when btn_type=momentary)
            double_shortpush_url 	0-2 	URL to access when switch is 2x pressed short (works only when btn_type=momentary)
            triple_shortpush_url 	0-2 	URL to access when switch is 3x pressed short (works only when btn_type=momentary)
            shortpush_longpush_url 	0-2 	URL to access when switch is pressed short + long (works only when btn_type=momentary)
            longpush_shortpush_url 	0-2 	URL to access when switch is pressed long + short (works only when btn_type=momentary)
            -------------------------------------------------------------------

            Button 1/2 - done

            shortpush_url 	        0 	URL to access when switch is pressed short
            double_shortpush_url 	0 	URL to access when switch is 2x pressed short
            triple_shortpush_url 	0 	URL to access when switch is 3x pressed short
            longpush_url 	        0 	URL to access when switch is pressed long
            -------------------------------------------------------------------

            Color bulb - done

            out_on_url 	    0 	URL to access when output is activated
            out_off_url 	0 	URL to access when output is deactivated
            -------------------------------------------------------------------

            Vintage /DUO/ Bulb rgbw - done

            out_on_url 	    0 	URL to access when output is activated
            out_off_url 	0 	URL to access when output is deactivated
            -------------------------------------------------------------------

            RGBW2 color - done

            btn_on_url 	        0 	URL to access when input switch is activated
            btn_off_url 	    0 	URL to access when input switch is deactivated
            btn_longpush_url 	0 	URL to access when input switch is held down.
            btn_shortpush_url 	0 	URL to access when input switch is pressed briefly.
            out_on_url 	        0 	URL to access when output is activated
            out_off_url 	    0 	URL to access when output is deactivated
            -------------------------------------------------------------------

            RGBW white output by switch channel

            btn_on_url 	        0 	URL to access when input switch is activated
            btn_off_url 	    0 	URL to access when input switch is deactivated
            btn_longpush_url 	0 	URL to access when input switch is held down.
            btn_shortpush_url 	0 	URL to access when input switch is pressed briefly.
            out_on_url 	        0-3 URL to access when output is activated
            out_off_url 	    0-3 URL to access when output is deactivated
            -------------------------------------------------------------------

            Dimmer 1/2 - done

            btn1_on_url 	    0 	URL to access when SW1 input is activated
            btn1_off_url 	    0 	URL to access when SW1 input is deactivated
            btn1_longpush_url 	0 	URL to access when SW1 input is held down. Works only when button is configured as detached
            btn1_shortpush_url 	0 	URL to access when SW1 input is pressed briefly. Works only when button is configured as detached
            btn2_on_url 	    0 	URL to access when SW2 input is activated
            btn2_off_url 	    0 	URL to access when SW2 input is deactivated
            btn2_longpush_url 	0 	URL to access when SW2 input is held down. Works only when button is configured as detached
            btn2_shortpush_url 	0 	URL to access when SW2 input is pressed briefly. Works only when button is configured as detached
            out_on_url 	        0 	URL to access when output is activated
            out_off_url 	    0 	URL to access when output is deactivated

            -------------------------------------------------------------------

            H&T - done

            report_url 	    0 	URL to report sensor events on (/?hum=60&temp=25.00&id=shellyht-xxxxxx)
            temp_over_url 	0 	URL to invoke when temperature > temp_over_value
            temp_under_url 	0 	URL to invoke when temperature < temp_under_value
            hum_over_url 	0 	URL to invoke when humidity > hum_over_value
            hum_under_url 	0 	URL to invoke when humidity < hum_under_value

            -------------------------------------------------------------------

            Smoke

            fire_detected_url 	0 	URL to access when fire condition is detected
            fire_gone_url 	    0 	URL to access when fire condition is not present anymore
            -------------------------------------------------------------------

            Flood - done

            report_url 	        0 	URL to report sensor events on (/?temp=25.00&flood=0&batV=1.00&id=shellyflood-xxxxxx)
            flood_detected_url 	0 	URL to access when flood is detected
            flood_gone_url 	    0 	URL to access when flood is gone
            temp_over_url 	    0 	URL to invoke when temperature > temp_over_value
            temp_under_url 	    0 	URL to invoke when temperature < temp_under_value
            -------------------------------------------------------------------

            Door 1/2 - done

            report_url 	        0 	URL to report sensor events on (/?state=open&lux=100&temp=25.00&tilt=1&vibration=0&id=shellydw2-xxxxxx)
            dark_url 	        0 	URL to invoke when luminance <= dark_threshold
            twilight_url 	    0 	URL to invoke when luminance > dark_threshold AND luminance <= twilight_threshold
            open_url 	        0 	URL to invoke on open
            close_url 	        0 	URL to invoke on close
            vibration_url 	    0 	URL to invoke on vibration detection
            temp_over_url 	    0 	Door/Window 2 only URL to invoke when temperature > temp_over_value
            temp_under_url 	    0 	Door/Window 2 only URL to invoke when temperature < temp_under_value
            -------------------------------------------------------------------

            Gas ensor - done

            alarm_off_url 	    0 	URL to access when gas alarm is gone
            alarm_mild_url 	    0 	URL to access when there is a mild gas alarm
            alarm_heavy_url 	0 	URL to access when there is a heavy gas alarm

            -------------------------------------------------------------------

            SHUNI - done

            btn_on_url 	        0-1 	URL to access when SW input is activated
            btn_off_url 	    0-1 	URL to access when SW input is deactivated
            out_on_url 	        0-1 	URL to access when output is activated
            out_off_url 	    0-1 	URL to access when output is deactivated
            longpush_url 	    0-1 	URL to access on longpush. Works only when button is configured as momentary, momentary_on_release or detached.
            shortpush_url 	    0-1 	URL to access on shortpush. Works only when button is configured as momentary, momentary_on_release or detached.
            adc_over_url 	    0 	URL to invoke when adc value > adc_over_value
            adc_under_url 	    0 	URL to invoke when adc value < adc_under_value
            ext_temp_over_url 	0-2 	If temperature sensor attached URL to invoke when temperature > ext_temp_over_value
            ext_temp_under_url 	0-2 	If temperature sensor attached URL to invoke when temperature < ext_temp_under_value
            ext_hum_over_url 	0 	If humidity sensor attached (DHT22 only) URL to invoke when humidity > ext_hum_over_value
            ext_hum_under_url 	0 	If humidity sensor attached (DHT22 only) URL to invoke when humidity < ext_hum_under_value
            -------------------------------------------------------------------


            EM

            out_on_url 	        0 	URL to access when output is activated
            out_off_url 	    0 	URL to access when output is deactivated
            over_power_url 	    0 	URL to invoke when over_power_url_threshold is reached
            under_power_url 	0 	URL to invoke when under_power_url_threshold is reached
        */
		//#endregion actions_description
		switch (action) {
			/**
			 * INPUT actions with indexes
			 */
			case 'btn1_on_url':
			case 'btn2_on_url':
				return $format('btn_index_on_url', {
					values: { index: action.charAt(3) },
				});

			case 'btn2_off_url':
			case 'btn1_off_url':
				return $format('btn_index_off_url', {
					values: { index: action.charAt(3) },
				});

			case 'btn2_longpush_url':
			case 'btn1_longpush_url':
				return $format('btn_index_longpush_url', {
					values: { index: action.charAt(3) },
				});

			case 'btn2_shortpush_url':
			case 'btn1_shortpush_url':
				return $format('btn_index_shortpush_url', {
					values: { index: action.charAt(3) },
				});

			case 'shortpush_url':
			case 'btn_shortpush_url':
				return $format('btn_shortpush_url');

			case 'longpush_url':
			case 'btn_longpush_url':
				return $format('btn_longpush_url');

			case 'double_shortpush_url':
				return $format('btn_double_shortpush_url');

			case 'triple_shortpush_url':
				return $format('btn_triple_shortpush_url');

			case 'shortpush_longpush_url':
				return $format('btn_shortpush_longpush_url');

			case 'longpush_shortpush_url':
				return $format('btn_longpush_shortpush_url');

			case 'over_power_url_1':
			case 'over_power_url_2':
			case 'over_power_url_3':
				return $format('over_power_index_url', {
					values: { index: action.split('_').pop() },
				});

			case 'under_power_url_1':
			case 'under_power_url_2':
			case 'under_power_url_3':
				return $format('under_power_index_url', {
					values: { index: action.split('_').pop() },
				});

			case 'valve_open':
			case 'valve_close':
			case 'motion_dark':
			case 'motion_off':
			case 'motion_twilight':
			case 'motion_bright':
			case 'motion_on':
			case 'tamper_alarm_on':
			case 'tamper_alarm_off':
			case 'bright_condition':
			case 'twilight_condition':
			case 'dark_condition':
				return $format(`${action}_url`);

			case 'sum_of_all_channels_under_power_urls':
			case 'sum_of_all_channels_over_power_urls':
			case 'over_power_url':
			case 'under_power_url':
			case 'btn_on_url':
			case 'btn_off_url':
			case 'out_on_url':
			case 'out_off_url':
			case 'roller_open_url':
			case 'roller_close_url':
			case 'roller_stop_url':
			case 'report_url':
			case 'temp_over_url':
			case 'temp_under_url':
			case 'hum_over_url':
			case 'hum_under_url':
			case 'flood_detected_url':
			case 'flood_gone_url':
			case 'dark_url':
			case 'twilight_url':
			case 'open_url':
			case 'close_url':
			case 'vibration_url':
			case 'alarm_off_url':
			case 'alarm_mild_url':
			case 'alarm_heavy_url':
			case 'lp_on_url':
			case 'lp_off_url':
			default:
				return $format(action);
		}
	};

	const retryActions = async (e) => {
		dispatch('retry');
		showHideActions();
	};

	onMount(async () => {
		showHideActions();
	});
</script>

{#if noActions}
	<FailedAction on:click={async (e) => await retryActions(e)} />
{:else if showActions}
	<HooksWrapperV2 bind:deviceActions on:actionsUpdate {type} />
{/if}
